import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/PaymentsConstant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var UpdatePayerAction = function () {

}

UpdatePayerAction.prototype = {

	update: function (userId) {
		restClient.updatePaymentOwner(localStorage.getItem('profileId'), userId, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else if (error.status === 404) {
					AppDispatcher.dispatch({
						actionType: Constant.UPDATE_OWNER,
						data: error
					});
				} else {
					AppDispatcher.dispatch({
						actionType: Constant.UPDATE_OWNER,
						data: error
					});
				}
			} else {
				response['status'] = 200;
				AppDispatcher.dispatch({
					actionType: Constant.UPDATE_OWNER,
					data: response
				});
			}
		})
	}
}

export default new UpdatePayerAction();